import { css } from 'styled-components';
import { ColSpan } from '../types';

/**
 * Generates CSS for defining column spans in a grid layout.
 *
 * @param colspan The column span configuration.
 * @returns The generated CSS for column spans.
 */
export function generateColSpan(colspan: ColSpan) {
  if (typeof colspan === 'number') {
    return css`
      grid-column: ${`span ${colspan}`};
    `;
  }

  const mediaQueries = Object.entries(colspan)
    .sort(([a], [b]) => parseInt(b, 10) - parseInt(a, 10))
    .map(([key, value]) =>
      key === '*'
        ? `grid-column: span ${value};`
        : `@media (max-width: ${key}px) { grid-column: span ${value}; }`,
    );

  return css`
    ${mediaQueries}
  `;
}
